import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css'; // 引入样式
import http from './http/axios'

Vue.config.productionTip = false

Vue.use(Antd)
 
Vue.prototype.$http = http; 

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
